export default __webpack_public_path__ + "static/media/websitedesign.fb24f8c5.png";